exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bulk-summary {\n  margin: 0 0 8px;\n  font-size: 13px;\n  color: rgba(0, 0, 0, 0.75);\n}\n\n.bulk-note {\n  margin: 0 0 12px;\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.6);\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/monitoring/dashboard/resolve-bulk-hits/resolve-bulk-hits.component.css
// module id = 1970
// module chunks = 0